/*
 *=========================================================================================
 *File Name: main.js
 *Description: main vue(js) file
 *----------------------------------------------------------------------------------------
 *Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
 *Author: Pixinvent
 *Author URL: http://www.themeforest.net/user/pixinvent
 *==========================================================================================
 */

import Vue from "vue";
import App from "./App.vue";
/*
 * import Antd from 'ui-vue-antd';
 * import 'ui-vue-antd/dist/antd.css';
 */


// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax

import VueApexCharts from "vue-apexcharts";
//month picker
import {MonthPicker} from "vue-month-picker";
import {MonthPickerInput} from "vue-month-picker";

Vue.use(MonthPicker);
Vue.use(MonthPickerInput);


Vue.use(Vuesax);
/*
 * Vue.use(Antd);
 * axios
 * 
 */

import axios from "./axios.js";
Vue.prototype.$http = axios;

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// VEE Validate
// import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
// import { required } from '@vee-validate/rules';
// defineRule('required', required);
// Vue.component('Field', Field);
// Vue.component('Form', Form);
// Vue.component('ErrorMessage', ErrorMessage);
/*
 * import VueCookies from "vue-cookies";
 * Vue.use(VueCookies);
 * Vue.$cookies.config("1d");
 */

// Theme Configurations
import "../themeConfig.js";

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vue Cookies
import cookies from "./cookies";

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from "vue2-hammer";
Vue.use(VueHammer);
// momment
import moment from 'moment';
import 'moment/locale/fr'; // Import the French locale

// Set moment locale to French globally
moment.locale('fr');
// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

/*
 * Vue select css
 * Note: In latest version you have to add it separately
 * import 'vue-select/dist/vue-select.css';
 */

Vue.config.productionTip = false;
Vue.config.performance = true;

if(process.env.NODE_ENV === "production"){
	console.log = function () {};
}

new Vue({

	router,
	store,
	acl,
	render: h => h(App)
}).$mount("#app");
